import { connect } from 'react-redux'

import { colors } from '@piconetworks/functions'

import Loader from 'common/modules/loader'
import xFrame from 'common/xFrame'

import Overlay from 'common/components/Overlay'

const mapsStateToProps = (state, { location = {} }) => {
    const linkColor = Loader.selectors.linkColor(state)
    const scopedLoader = state.loader.user || state.loader.guest
    const { cover_photo: coverPhoto = null } = scopedLoader?.publisher || {}

    const { pathname = '' } = location

    const avatarPages = [
        '/select-plan',
        '/login/enter-email',
        '/thank-you',
        '/group/join',
        '/select-donation',
        '/redeem-gift',
        '/login/signup-link',
    ]

    const isAvatarPage = avatarPages.reduce((pageFound, avatarPage) => {
        if (pageFound || pathname.includes(avatarPage)) {
            return true
        }

        if (pathname.includes(avatarPage)) {
            return true
        }

        return pageFound
    }, false)

    return {
        linkColor,
        contrastColor: colors.getContrastColor(linkColor),
        coverPhoto,
        logoColor: scopedLoader?.publisher?.logoColor,
        avatarImg: scopedLoader?.publisher?.icon,
        isAvatarPage,
    }
}

const mapDispatchToProps = (dispatch) => ({
    showLauncher: () => {
        xFrame.prompt.showLauncher({ dispatch })
    },
})

export default connect(
    mapsStateToProps,
    mapDispatchToProps,
)(Overlay)
